import React, { createContext, useContext, useMemo } from 'react'
import { useAuth } from '@context/AuthContext/AuthContext'
import { useCausesData } from '@hooks/useCausesData'
import { CausesContextProps, CausesContextDefaultValues } from '@Interfaces/Data/CauseInterface'

export const CausesContext = createContext<CausesContextProps>(CausesContextDefaultValues)

import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const CausesProvider = ({ children }: ContextComponentProps) => {
  const { currentUser } = useAuth()
  const { allCauses, setAllCauses, ourCauses, setOurCauses } = useCausesData(currentUser)

  const contextValue = useMemo(
    () => ({
      allCauses,
      setAllCauses,
      ourCauses,
      setOurCauses,
    }),
    [allCauses, ourCauses]
  )

  return <CausesContext.Provider value={contextValue}>{children}</CausesContext.Provider>
}

export const useCauses = (): CausesContextProps => useContext(CausesContext)
